import React from 'react';
import './Error.css';

const Error = ({ message, onRetry, retryText = 'Try Again' }) => {
  return (
    <div className="error-container">
      <div className="error-icon">⚠️</div>
      <h3 className="error-title">Something went wrong</h3>
      <p className="error-message">{message}</p>
      {onRetry && (
        <button className="btn btn-primary" onClick={onRetry}>
          {retryText}
        </button>
      )}
    </div>
  );
};

export default Error;